<template>
  <div>
    <div v-if="!loading">
      <treeselect v-model="selectedValue"
        :clearable="clearable"
        :searchable="true"
        :multiple="multiple"
        :options="terms"
        :show-count="showCount"
        :default-expand-level="explandLevel"
        @input="handleChanged" />
    </div>
    <div v-else>
      <Input :disabled="true"></Input>
    </div>
  </div>
</template>

<script>
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { mapActions } from 'vuex'
export default {
  name: 'TaxonomyTermSelect',
  components: {
    Treeselect
  },
  props: {
    termId: {
      type: [Array, Number],
      default: () => {
        return []
      }
    },
    slug: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    explandLevel: {
      type: Number,
      default: null
    },
    showCount: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      terms: [],
      selectedValue: null,
      loading: false
    }
  },
  mounted() {
    this.handleInit()
    this.handleLoadTerms()
  },
  watch: {
    termId: function () {
      this.handleInit()
    }
  },
  methods: {
    ...mapActions([
      'getTaxonomyTerms'
    ]),
    handleInit() {
      if (this.multiple && !(this.termId instanceof Array)) {
        this.selectedValue = [this.termId]
      } else {
        this.selectedValue = this.termId
      }
    },
    handleLoadTerms() {
      this.loading = true
      this.getTaxonomyTerms(this.slug).then((res) => {
        _.each(res, (t) => {
          this.filterEmptyChildrens(t)
        })
        this.terms = res
      }).finally(() => {
        this.loading = false
      })
    },
    handleEmit() {
      this.$emit('update:termId', this.selectedValue)
      this.$emit('on-changed', this.selectedValue)
    },
    handleChanged () {
      this.handleEmit()
    },
    filterEmptyChildrens(term) {
      if (term.children) {
        if (_.isEmpty(term.children)) {
          delete term.children
        } else {
          _.each(term.children, (t) => {
            this.filterEmptyChildrens(t)
          })
        }
      }
    },
    handleLoadOptions () {
      return []
    }
  }
}
</script>
